import ClientPassengerInterface from '../../interfaces/client/Passenger'

export const CREATE_BOOKING = 'CREATE_BOOKING'

export default (
  flightIds: string[],
  passengers: ClientPassengerInterface[]
) => ({
  type: CREATE_BOOKING,
  flightIds,
  passengers,
})
